export { default as SearchIcon } from './SearchIcon';
